import { HomeMessage, MessageLabels } from '../types'
import useMessageCard from './useMessageCard'
import { CardHeader, CardTitleButton, CardTitleText, MessageCardRoot } from './styled-components'

interface MessageCardProps {
  message: HomeMessage
  expanded: boolean
  labels: MessageLabels
  onToggle: (message: HomeMessage) => void
}

const MessageCard = ({ message, expanded, labels, onToggle }: MessageCardProps) => {
  const { title, Chevron, onClick } = useMessageCard({ message, expanded, labels, onToggle })

  return (
    <MessageCardRoot $active={expanded} id={`home-message-${message.id}`}>
      <CardHeader>
        <CardTitleButton type='button' $active={expanded} aria-expanded={expanded} onClick={onClick}>
          <CardTitleText>{title}</CardTitleText>
          <Chevron size={20} />
        </CardTitleButton>
      </CardHeader>
    </MessageCardRoot>
  )
}

export default MessageCard
